<div [copoScroller] class="sidenav-content" @routeAnimation>
	<ng-container *ngIf="!isMainLoading && issue else loading">
		<div class="card-title-block-non-sticky">
			<copo-back-button></copo-back-button>
			<span class="card-title-label" translate>issue.issuecard</span>
			<span class="card-title-label">{{ issue.customerReference ? issue.customerReference : UNDERSCORE }}</span>
			<div class="card-title-label">
				<span *ngIf="issue.status !== undefined" translate>claim.current.statusddot</span>
				{{ issue.status !== undefined ? (getIssueStatusTr(issue) | translate) : UNDERSCORE }}
				{{ issue.closedDate ? '(' + (issue.closedDate | copoDate:'datetime') + ')' : '' }}
				<!-- display received amount value only if it is filled (not 0) -->
				{{ issue.amountAccepted
					? (absoluteValue(issue.amountAccepted | copoTextToNumber) | copoNumber:'amount':getUnitAmount(issue.currencyAccepted))
					: ''
				}}
			</div>
			<div class="page-header-action-panel">
				<button type="submit" mat-flat-button color="primary" class="edit-feedback-button"
					*ngIf="user.isClaimValidator() && isModifiable(issue)"
					[routerLink]="['../../edit/' + issue.steeluserId + '/quality-issue-entry']">
					<span translate>quapp.action.edit</span>
					<mat-icon iconPositionEnd class="mat-icon" svgIcon="copo_pencil"></mat-icon>
				</button>
				<button type="button" mat-flat-button
					*ngIf="user.isClaimValidator() && isModifiable(issue)" (click)="evtCancelIssue(issue)">
					<span translate>quapp.action.cancel</span>
				</button>
			</div>
		</div>
		<div class="grid-6 copo-container footer-margin">
			<div class="grid-column-one-full">
				<mat-expansion-panel [expanded]="true" class="card-info-block">
					<mat-expansion-panel-header>
						<mat-panel-title class="card-content-title">
							<span translate>issue.issueinformation</span>
						</mat-panel-title>
					</mat-expansion-panel-header>
					<mat-divider class="margin-expansion-panel"></mat-divider>
					<div class="card-content-block triple-column">
						<div class="card-contents-infos">
							<div class="card-content-info">
								<div class="card-content-label" translate>claim.request.type</div>
								<div class="card-content-value">{{ issue.issueType ? ( getIssueTypeTr(issue.issueType) | translate) : UNDERSCORE }}</div>
							</div>
							<div class="card-content-info" *ngIf="issue.claimType">
								<div class="card-content-label" translate>claim.claimtype.label</div>
								<div class="card-content-value">{{ (issue.claimType === 'ZL' ? 'claim.type.zl' : 'claim.type.zr') | translate }}</div>
							</div>
							<div class="card-content-info">
								<div class="card-content-label" translate>order.creation.date</div>
								<div class="card-content-value">{{ issue.creationDate ? (issue.creationDate | copoDate:'date') : UNDERSCORE }}</div>
							</div>
							<div class="card-content-info">
								<div class="card-content-label" translate>issue.creditnotedate</div>
								<div class="card-content-value">{{ issue.creditNoteDate
										? (issue.creditNoteDate | copoDate:'date')
										: UNDERSCORE }}</div>
							</div>
							<div class="card-content-info">
								<div class="card-content-label" translate>issue.closingdate</div>
								<div class="card-content-value">{{ isClosed(issue) ? (issue.closedDate | copoDate:'datetime') : UNDERSCORE }}</div>
							</div>
							<div class="card-content-info">
								<div class="card-content-label" translate>claim.current.status</div>
								<div class="card-content-value">{{ issue && issue.status !== undefined ? (getDecisionTr(issue) | translate) : UNDERSCORE }}</div>
							</div>
							<div class="card-content-info">
								<div class="card-content-label" translate>claim.comment</div>
								<div class="card-content-value card-info-value-pre">{{
									issue.comment && issue.comment !== '' ? issue.comment : UNDERSCORE }}</div>
							</div>
							<div class="card-content-info">
								<div class="card-content-label" translate>issue.origin</div>
								<div class="card-content-value card-info-value-pre">{{
									issue.origin && issue.origin !== '' ? getIssueOriginTr(issue.origin) : '' }}</div>
							</div>
						</div>
						<div class="card-contents-infos">
							<div class="card-content-info">
								<div class="card-content-label" translate>claim.impacted.quantity</div>
								<div class="card-content-value">{{ issue.qtyRequested
									? (issue.qtyRequested | copoNumber:'weight':getQuantityUnit(issue.weightUnitRequested))
									: UNDERSCORE }}
								</div>
							</div>
							<div class="card-content-info">
								<div class="card-content-label" translate>claim.amount.for.other.costs</div>
								<div class="card-content-value">{{ issue.otherCostAmount
									? (issue.otherCostAmount | copoNumber:'amount':getUnitAmount(issue.currencyRequested))
									: UNDERSCORE}}
								</div>
							</div>
							<div class="card-content-info" *ngIf="issue.claimType === 'ZR'">
								<div class="card-content-label" translate>claim.requested.material.costs</div>
								<div class="card-content-value">{{ issue.amountRequested
										? (issue.amountRequested | copoNumber:'amount':getUnitAmount(issue.currencyRequested))
										: UNDERSCORE }}
								</div>
							</div>
							<div class="card-content-info">
								<div class="card-content-label" translate>claim.total.requested.calculated</div>
								<div class="card-content-value" *ngIf="issue.claimType !== 'ZR'">{{ issue.amountRequested
										? (issue.amountRequested | copoNumber:'amount':getUnitAmount(issue.currencyRequested))
										: UNDERSCORE }}
								</div>
								<div class="card-content-value" *ngIf="issue.claimType === 'ZR'">{{ ((issue.amountRequested || 0) + (issue.otherCostAmount || 0)) | copoNumber:'amount':getUnitAmount(issue.currencyRequested) }}</div>
							</div>
							<div class="card-content-info">
								<div class="card-content-label" translate>claim.defect</div>
								<div class="card-content-value">
									{{ issue.customerDefectDetailedDescription && issue.customerDefectDetailedDescription !== ''
										? issue.customerDefectDetailedDescription
										: (issue.customerDefectDetailed && issue.customerDefectDetailed !== ''
											? (getDefectOption(issue.customerDefectDetailed).label | translate)
											: UNDERSCORE)
									}}
								</div>
							</div>
							<div class="card-content-info">
								<div class="card-content-label" translate>claim.placeholder.reference.number</div>
								<div class="card-content-value">{{ issue.customerReference ? issue.customerReference : UNDERSCORE }}</div>
							</div>
							<div class="card-content-info">
								<div class="card-content-label" translate>order.customer.order.number</div>
								<div class="card-content-value">{{ order
										? (order.customerOrderNumber + '/' + order.customerOrderItemNumber)
										: UNDERSCORE }}
								</div>
							</div>
							<div class="card-content-info">
								<div class="card-content-label" translate>supplier.comment</div>
								<div class="card-content-value card-info-value-pre">{{
									issue.supplierComment && issue.supplierComment !== '' ? issue.supplierComment : UNDERSCORE }}</div>
							</div>
						</div>
						<div class="card-contents-infos">
							<div class="card-content-info">
								<div class="card-content-label" translate>issue.acceptedquantity</div>
								<div class="card-content-value">{{ issue.qtyAccepted
									? (issue.qtyAccepted | copoNumber:'weight':'t')
									: UNDERSCORE }}
								</div>
							</div>
							<div class="card-content-info">
								<div class="card-content-label" translate>claim.paid.amount</div>
								<div class="card-content-value">
									{{ issue.amountAccepted
										? (absoluteValue(issue.amountAccepted | copoTextToNumber) | copoNumber:'amount':getUnitAmount(issue.currencyAccepted))
										: UNDERSCORE
									}}
								</div>
							</div>
							<div class="card-content-info">
								<div class="card-content-label" translate>issue.supplierdefect</div>
								<div class="card-content-value">
									{{ issue.supplierDefectDescription && issue.supplierDefectDescription !== ''
											? issue.supplierDefectDescription
											: (issue.supplierDefect && issue.supplierDefect !== ''
												? issue.supplierDefect
												: UNDERSCORE)
									}}
								</div>
							</div>
							<div class="card-content-info">
								<div class="card-content-label" translate>issue.supplierissuenumber</div>
								<div class="card-content-value">{{ issue.supplierIssueNumber ? issue.supplierIssueNumber : UNDERSCORE }}</div>
							</div>
							<div class="card-content-info">
								<div class="card-content-label" translate>order.supplier.order.number</div>
								<a *ngIf="order else noLink"
									class="card-content-value copo-link"
									[routerLink]="['/', 'order-tracking', 'order', 'card',
										order.supplierOrderNumber,
										order.supplierOrderItemNumber]">
									{{ order.supplierOrderNumber + '/' + order.supplierOrderItemNumber }}
								</a>
								<ng-template #noLink>
									<div class="card-content-value">
										{{ (issue.supplierOrderNumber && issue.supplierOrderItemNumber
											? issue.supplierOrderNumber + '/' + issue.supplierOrderItemNumber
											: UNDERSCORE) }}
									</div>
								</ng-template>
							</div>
							<div class="card-content-info">
								<div class="card-content-label" translate>order.supplier</div>
								<div class="card-content-value">{{ order | copoModelInfo:'supplierDescription':ARCELOR_SUPPLIER_DESC }}</div>
							</div>
							<div class="card-content-info">
								<div class="card-content-label" translate>order.mill</div>
								<div class="card-content-value">{{ order | copoModelInfo:'millDescription' }}</div>
							</div>
							<div class="card-content-info">
								<div class="card-content-label" translate>order.mill.order.number</div>
								<div class="card-content-value">{{ order
										? order.millOrderNumber + '/' + order.millOrderItemNumber
										: UNDERSCORE }}
								</div>
							</div>
						</div>
					</div>
				</mat-expansion-panel>
			</div>

			<div class="grid-column-one-half">
				<mat-expansion-panel [expanded]="true" class="card-info-block">
					<mat-expansion-panel-header>
						<mat-panel-title class="card-content-title">
							<span translate>order-tracking.product</span>
						</mat-panel-title>
					</mat-expansion-panel-header>
					<mat-divider class="margin-expansion-panel"></mat-divider>
					<div class="card-content-block double-column">
						<div class="card-contents-infos">
							<div class="card-content-info" *ngIf="getCharacteristic('PD02')">
								<div class="card-content-label">{{ getCharacteristic('PD02')?.description }}</div>
								<div class="card-content-value">{{ getCharacteristic('PD02') | copoCharac }}</div>
							</div>
							<div class="card-content-info">
								<div class="card-content-label" translate>order-tracking.product.description</div>
								<div class="card-content-value">{{ order | copoModelInfo:'productDescription' }}</div>
							</div>
							<div class="card-content-info" *ngIf="getCharacteristic('SU09')">
								<div class="card-content-label">{{ getCharacteristic('SU09')?.description }}</div>
								<div class="card-content-value">{{ getCharacteristic('SU09') | copoCharac }}</div>
							</div>
							<div class="card-content-info">
								<div class="card-content-label" translate>order.customer.article.reference</div>
								<div class="card-content-value">{{ order | copoModelInfo:'customerArticleReference' }}</div>
							</div>
							<div class="card-content-info" *ngIf="getCharacteristic('PD03')">
								<div class="card-content-label">{{ getCharacteristic('PD03')?.description }}</div>
								<div class="card-content-value">{{ getCharacteristic('PD03') | copoCharac }}</div>
							</div>
							<div class="card-content-info">
								<div class="card-content-label" translate>order-tracking.choice</div>
								<div class="card-content-value">{{ order | copoModelInfo:'choiceDescription' }}</div>
							</div>
						</div>
						<div class="card-contents-infos">
							<div class="card-content-info" *ngIf="getCharacteristic('QU02')">
								<div class="card-content-label">{{ getCharacteristic('QU02')?.description }}</div>
								<div class="card-content-value">{{ getCharacteristic('QU02') | copoCharac }}</div>
							</div>
							<div class="card-content-info" *ngIf="getCharacteristic('QU01')">
								<div class="card-content-label">{{ getCharacteristic('QU01')?.description }}</div>
								<div class="card-content-value">{{ getCharacteristic('QU01') | copoCharac }}</div>
							</div>
							<div class="card-content-info" *ngIf="getCharacteristic('DI03')">
								<div class="card-content-label">{{ getCharacteristic('DI03')?.description }}</div>
								<div class="card-content-value">{{ getCharacteristic('DI03') | copoCharac }}</div>
							</div>
							<div class="card-content-info" *ngIf="getCharacteristic('DI06')">
								<div class="card-content-label">{{ getCharacteristic('DI06')?.description }}</div>
								<div class="card-content-value">{{ getCharacteristic('DI06') | copoCharac }}</div>
							</div>
							<div class="card-content-info" *ngIf="getCharacteristic('WG11')">
								<div class="card-content-label">{{ getCharacteristic('WG11')?.description }}</div>
								<div class="card-content-value">{{ getCharacteristic('WG11') | copoCharac }}</div>
							</div>
						</div>
					</div>
				</mat-expansion-panel>
			</div>
			<div class="grid-column-one-half">
				<mat-expansion-panel [expanded]="true" class="card-info-block">
					<mat-expansion-panel-header>
						<mat-panel-title class="card-content-title">
							<span translate>order.customer</span>
						</mat-panel-title>
					</mat-expansion-panel-header>
					<mat-divider class="margin-expansion-panel"></mat-divider>
				<div class="card-content-block double-column">
					<div class="card-contents-infos">
						<div class="card-content-info">
							<div class="card-content-label" translate>order.customer</div>
							<div class="card-content-value">{{ order | copoModelInfo:'soldToDescription' }}</div>
						</div>
						<div class="card-content-info">
							<div class="card-content-label" translate>order.ship.to</div>
							<div class="card-content-value">{{ order | copoModelInfo:'shipToDescription' }}</div>
						</div>
					</div>
					<div class="card-contents-infos">
						<div class="card-content-info">
							<div class="card-content-label" translate>order.enduser</div>
							<div class="card-content-value">{{ order | copoModelInfo:'endUserDescription' }}</div>
						</div>
						<div class="card-content-info">
							<div class="card-content-label" translate>order.bill.to</div>
							<div class="card-content-value">{{ order | copoModelInfo:'billToDescription' }}</div>
						</div>
					</div>
				</div>
				</mat-expansion-panel>
			</div>

			<ng-container *ngIf="!isLoading else loading">
				<div class="grid-column-one-full" *ngIf="attachmentsGridOptions">
					<mat-expansion-panel [expanded]="true" class="card-info-block">
						<mat-expansion-panel-header>
							<mat-panel-title class="card-content-title">
								<span translate>claim.attachments</span>
							</mat-panel-title>
						</mat-expansion-panel-header>
						<mat-divider class="margin-expansion-panel"></mat-divider>
						<div class="copo-card-grid-container card-grid-padding">
							<ag-grid-angular
								class="ag-theme-balham"
								[gridOptions]="attachmentsGridOptions"
								[modules]="agGridModules"
								(gridReady)="onGridReady($event)"
								(viewportChanged)="onViewportChanged($event)"
								></ag-grid-angular>
						</div>
					</mat-expansion-panel>
				</div>

				<div class="grid-column-one-full" *ngIf="gridBatchesOptions">
					<mat-expansion-panel [expanded]="true" class="card-info-block">
						<mat-expansion-panel-header>
							<mat-panel-title class="card-content-title">
								<span translate>issue.batchesassociated</span>
							</mat-panel-title>
						</mat-expansion-panel-header>
						<mat-divider class="margin-expansion-panel"></mat-divider>
						<div class="copo-card-grid-container card-grid-padding">
							<ag-grid-angular
								class="ag-theme-balham"
								[gridOptions]="gridBatchesOptions"
								[modules]="agGridModules"
								(gridReady)="onGridReady($event)"
								(viewportChanged)="onViewportChanged($event)"
								></ag-grid-angular>
						</div>
					</mat-expansion-panel>
				</div>

				<div class="grid-column-one-full"
				#documents
				copoAfterViewInit
				(afterviewinit)="autoScrollToElement(documents)"
				*ngIf="gridCommercialDocumentsOptions">
					<mat-expansion-panel [expanded]="true" class="card-info-block">
						<mat-expansion-panel-header>
							<mat-panel-title class="card-content-title">
								<span class="card-title" translate>order-card.commercial-documents</span>
							</mat-panel-title>
						</mat-expansion-panel-header>
						<div id="documents" class="copo-card-grid-container">
							<ag-grid-angular
									class="ag-theme-balham"
									[gridOptions]="gridCommercialDocumentsOptions"
									[modules]="agGridModules"
									(gridReady)="onGridReady($event)"
									(viewportChanged)="onViewportChanged($event)"
							></ag-grid-angular>
						</div>
					</mat-expansion-panel>
				</div>
			</ng-container>
		</div>
	</ng-container>
</div>

<ng-template #loading>
	<ng-container *ngIf="isLoading">
		<copo-loading-spinner></copo-loading-spinner>
	</ng-container>
</ng-template>
